import {Injectable} from "@angular/core";
import {BaseApi} from "./baseService";
import {Http, QueryEncoder, RequestOptions, URLSearchParams} from "@angular/http";
import {CustomerSearchRequest} from "../objects/requests/customerSearchRequest";
import {BaseResponse} from "../objects/common/baseResponse";
import {SearchResponse} from "../objects/responses/searchResponse";
import {Customer} from "../objects/customers/customer";
import {ConfigService} from "./configService";
import {Order} from "../objects/orders/order";
import { CustomerModifyRequest } from "../objects/requests/customerModifyRequest";
import { CustomerPaymentRequest } from "../objects/customers/customer-payment-request";
/**
 * Created by alex.y on 9/7/2017.
 */

@Injectable()
export class CustomerService extends BaseApi{
    constructor(http: Http, configService: ConfigService) {
        super(http, configService);
    }

    public search(request: CustomerSearchRequest ): Promise<BaseResponse<SearchResponse<Customer>>>{
        let params = new URLSearchParams();

        params.append('query', encodeURIComponent(request.Query));
        params.append('top', request.Top.toString());
        params.append('skip', request.Skip.toString());
        params.append('orderBy', request.OrderBy.PropertyName);
        params.append('orderByDir', request.OrderBy.OrderBy.toString());
        params.append('fillOrders', request.FillOrders.toString());

        return this.get(new RequestOptions({
            url: `customer/search`,
            search: params
        }));
    }

    public update(request: CustomerModifyRequest ) : Promise<BaseResponse<Customer>>{
        return this.put(new RequestOptions({
            url: `customer/modify`,
            body: request
        }));
    }

    public create(customer: Customer ) : Promise<BaseResponse<Customer>>{
        return this.post(new RequestOptions({
            url: `customer/createinternal`,
            body: customer
        }));
    }

    public updateInPipeDrive(customer: Customer ) : Promise<BaseResponse<Customer>>{
        return this.put(new RequestOptions({
            url: `customer/modify/pipedrive`,
            body: customer
        }));
    }

    public getByCustomerId(customerId: number, skip: number = 0, top: number = 10): Promise<BaseResponse<SearchResponse<Order>>> {
        let params = new URLSearchParams();

        params.append('top', top.toString());
        params.append('skip', skip.toString());

        return this.get(new RequestOptions({
            url: `customer/${customerId}/orders`,
            search: params
        }));
    }


    public getCustomerById(customerId:number): Promise<BaseResponse<Customer>> {
        return this.get(new RequestOptions({
            url: `customer/${customerId}`,
        }));
    }

    public getCustomerPayDataById(customerId: number): Promise<BaseResponse<CustomerPaymentRequest>> {
        return this.get(new RequestOptions({
            url: `customer/paydata/${customerId}`,
        }));
    }
}



// WEBPACK FOOTER //
// ./app/services/customerService.ts